export default __webpack_public_path__ + "static/media/risto.49b5a721.svg";